import axios from 'axios'
import security from '@/services/security.js'

export default {
  uploadPhoto (courseKey, scouterKey, file) {
    const securityHeader = security.getAuthHeader()
    const contentHeader = { 'Content-Type': 'multipart/form-data' }
    const config = {
      ...securityHeader,
      ...contentHeader
    }
    const msg = new FormData()
    msg.append('file', file)
    return axios.post('/files/' + courseKey + '/' + scouterKey, msg, config)
      .then(response => {
        return response.data
      })
  },
  uploadFile (courseKey, file) {
    const securityHeader = security.getAuthHeader()
    const contentHeader = { 'Content-Type': 'multipart/form-data' }
    const config = {
      ...securityHeader,
      ...contentHeader
    }
    const msg = new FormData()
    msg.append('file', file)
    return axios.post('/files/' + courseKey, msg, config)
      .then(response => {
        return response.data
      })
  }
}
